import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { SwalProvider } from './component/sweetalert';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <SwalProvider>
    <App />

    </SwalProvider>
   
  </React.StrictMode>
);


reportWebVitals();
